var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBowTie(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "30mm",
    height: 58.265,
    viewBox: "0 0 30 15.416",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -281.584)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-178.694 -50.189 237.446) scale(.57399)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.35278 0 0 -.35278 -205.957 325.272)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9ad426",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l45.249 34.853S72.65 29.284 59.806 5.951c0 0 15.628-30.614-4.924-44.528L0-18.882z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.35278 0 0 -.35278 -199.894 325.285)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9ad426",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l45.249 34.853S72.65 29.284 59.806 5.951c0 0 15.628-30.614-4.924-44.528L0-18.882z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.35278 0 0 -.35278 -196.383 332.263)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9ad426",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0a3.425 3.425 0 00-3.425-3.425h-28.85A3.425 3.425 0 00-35.701 0v25.521a3.426 3.426 0 003.426 3.426h28.85A3.426 3.426 0 000 25.521z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.35278 0 0 -.35278 -219.607 323.183)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f4bb36",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0a7.82 7.82 0 110-15.64A7.82 7.82 0 010 0m-18.337-16.143a7.82 7.82 0 110-15.64 7.82 7.82 0 010 15.64m0 34.99a7.778 7.778 0 01-5.142-1.939c-1.298-3.139-1.552-7.036.088-11.843a7.788 7.788 0 015.054-1.857 7.819 7.819 0 017.819 7.819c0 4.319-3.5 7.82-7.819 7.82m43.849-34.99a7.82 7.82 0 01-7.82-7.819 7.813 7.813 0 014.258-6.955l8.817 3.2c.265-.374.606-.687.996-.929a7.77 7.77 0 011.569 4.684 7.82 7.82 0 01-7.82 7.819m0 19.351c.395 0 .78.038 1.159.095l-8.931 6.879a7.82 7.82 0 017.772-6.974m48.786-19.351a7.82 7.82 0 01-7.82-7.819 7.79 7.79 0 012.255-5.49l6.373-2.287a7.82 7.82 0 01-.808 15.596M92.635 0a7.82 7.82 0 110-15.64 7.82 7.82 0 010 15.64M43.849 0a7.82 7.82 0 110-15.64 7.82 7.82 0 010 15.64m69.361-16.143a7.82 7.82 0 110-15.639 7.82 7.82 0 010 15.639m0 19.351c1.736 0 3.335.572 4.633 1.53 1.834 5.152 1.51 9.274.042 12.547a7.768 7.768 0 01-4.675 1.562 7.82 7.82 0 010-15.639M77.151 10.43l-9.202-7.088a7.823 7.823 0 011.412-.134c4.117 0 7.483 3.184 7.79 7.222"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBowTie);
export default __webpack_public_path__ + "static/media/bow-tie.c649593ad123a500f46b792ba4efbabf.svg";
export { ForwardRef as ReactComponent };